import PropTypes from "prop-types";
import { useEffect } from "react";

/**
 * @typedef Props
 * @prop {string} [variant]
 */
/**
 * @param {Props} props
 */
export const BaseTheme = ({ variant = "light" }) => {
  const toggleTheme = () => {
    const bodyElement = document.querySelector("body");
    bodyElement?.setAttribute("motif-theme", variant);
    bodyElement?.classList.forEach((className) => {
      if (className.startsWith("motif-theme-")) {
        bodyElement.classList.remove(className);
      }
    });
    bodyElement?.classList.add(`motif-theme-${variant}`);
  };

  useEffect(() => {
    toggleTheme();
  }, [variant]);

  return null;
};

BaseTheme.propTypes = {
  variant: PropTypes.string
};
